import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy,
    Output,
    EventEmitter,
    Input,
    ViewChild,
    Renderer2,
    ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {StocksService} from 'app/stocks/services/stocks.service';
import {CommonDataService} from 'app/services/common-data.service';
import {StocksFilterService} from "app/stocks/services/stocks-filter.service";
import {ChartHelper} from "app/buffer-graph/models/chart-helper";
import {ITabInfo} from "../../models/tab-info-interface";

type InitialData = { accessDenied: boolean, rights: any };

@Component({
    selector: 'tabs-header',
    templateUrl: './tabs-header.component.html',
    styleUrls: ['./tabs-header.component.css']
})
export class TabsHeaderComponent implements OnInit, AfterViewInit, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                public readonly commonData: CommonDataService,
                ){


        this.helper = new ChartHelper();
        this.close = new EventEmitter<ITabInfo>();
        this.updateState = new EventEmitter<boolean>();
        this.tooltipFunc = new Function('cell', '$("[data-toggle=tooltip]", cell).tooltip({ boundary: "window" });');
    }

    private initialise = (): void =>{
        // this.helper = new ChartHelper();
    };


    private _dateChanged: boolean;
    @Input()
    set dateChanged(val: boolean) {
        if (val !== this.dateChanged){
            this._dateChanged = val;
        }
    };

    get dateChanged(): boolean {
        return this._dateChanged;
    };

    @Input() private tabHeader: any;
    @Input() private GUID: string;

    @Output()
    private readonly close: EventEmitter<ITabInfo>;

    @Output()
    private readonly updateState: EventEmitter<boolean>;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    @ViewChild('tooltipEl')
    private tooltipEl: ElementRef;

    private helper: ChartHelper;

    private tooltip: string;

    private translates: any;

    private tooltipFunc: Function;
    // private popperAddVar: Popper;
    // private listenContextMenu: () => void;
    // private listenMouseDown: () => void;

    async ngOnInit(){
        this.translates = await this.translateService.get(['Warehouse', 'SKU', 'Period']).toPromise();
        await this.generateTooltip();
    }

    ngOnDestroy(){

    }

    ngAfterViewInit(){
        this.helper.wait(() => $(this.tooltipEl.nativeElement).tooltip({template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner large"></div></div>'}));
    }

    //# close tab
    public removeTab = (tab: ITabInfo): void =>{
        this.close.emit(tab);
    }

    //# generate tooltip
    private generateTooltip = async (): Promise<void> => {
        let header = await this.translateService.get(this.tabHeader.header).toPromise();
        this.tooltip = `<div class="text-truncate" style="width: 350px">
                            <span>${header}</span><br/>
                            <span>${this.translates.Warehouse}: ${this.tabHeader.itemInfo.warehouseCode} ${this.tabHeader.itemInfo.warehouseName}</span><br/>
                            <span>${this.translates.SKU}: ${this.tabHeader.itemInfo.sku} ${this.tabHeader.itemInfo.name}</span><br/>
                            <span>${this.translates.Period}: ${this.tabHeader.startDate.format(this.helper.ru_Date)}-${this.tabHeader.endDate.format(this.helper.ru_Date)}</span>
                       </div>`;
    }
}




// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/tabs-header.component/tabs-header.component.ts